export default __webpack_public_path__ + "static/media/Jael_Joseph_AHV_In_Moms_We_Trust.72719bd7.jpg";